import Email from './email/Email';
import Token from './token/Token';
import oauth from 'components/auth/login/integrations/oauth';

export default {
	email: Email,
	token: Token,
	...oauth,
};
